import { Controller } from "stimulus"
export default class extends Controller {
  static get targets(){
    return ['source'];
  }

  copy(){
    if (this.sourceTarget.nodeName != 'INPUT') { 
      var node = document.createElement('input'); 
      node.value = this.sourceTarget.innerText;
    this.sourceTarget.append(node); 
    node.focus();
    node.select();
    }
    else { 
      this.sourceTarget.select();

    }

    document.execCommand("copy")
    if (node){
     node.remove();

    }


  }

}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/clipboard_controller.js